import { useState } from 'react'
import { apiFetch } from '@common/utils/apiFetch'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/types'
import { buildWorkCountApiUrl } from '@pc/components/Works/Panel/utils/workSearchApi'

const useWorksCount = () => {
  const [worksCount, setWorksCount] = useState(0)

  const updateCountFromParams = (mergedParams: SearchParamsAttributes) => {
    const endPoint: string = buildWorkCountApiUrl(mergedParams)
    apiFetch(endPoint)
      .then(async (res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`)
        setWorksCount((await res.json()) as number)
      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  return { worksCount, updateCountFromParams }
}

export default useWorksCount
